import React, { useState } from "react";
import ToggleSwitch from "../ToggleSwitch";
import SettingsData from "./SettingsData";
import _ from "lodash";
import {
  useAdminUser,
  useGetFunctionality,
  useUpdateFunctionalityGeneral,
} from "../../../sevices/hooks/admin";
import { IoChevronBackOutline } from "react-icons/io5";
import { IoChevronForward } from "react-icons/io5";
import { useNavigate, useParams } from "react-router-dom";
import { useUpdateFunctionality } from "../../../sevices/hooks/meta-data";
import StepperController from "./stepper/StepperController";
import { toast } from "react-toastify";

interface ToggleState {
  [description: string]: boolean;
}

const IndividualFunctionality = () => {
  const [switchToggle, setSwitchToggle] = useState(false);
  const { id } = useParams();
  const updateUser = useUpdateFunctionality(id as string);
  const acc = useAdminUser(id as string);
  const account = acc?.data?.data.data;
  const { data: functionality, refetch } = useGetFunctionality();
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const allFunctionality = useUpdateFunctionalityGeneral();
  const [toggleAll, setToggleAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const [toggleState, setToggleState] = useState<{ [key: string]: boolean }>(
    {}
  );
  console.log(account, "gtg");
  const handleToggleChange = (description: string, value: boolean) => {
    setToggleState((prevState) => ({
      ...prevState,
      [description]: value,
    }));
  };

  const handleToggleAll = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    const newState: ToggleState = {};
    const newToggleState = !toggleAll;

    Object.keys(toggleState).forEach((description) => {
      newState[description] = newToggleState;
    });
    setToggleState(newState);
    setToggleAll(newToggleState);
  };

  const navigate = useNavigate();

  const handleSubmit = () => {
    setLoading(true);
    updateUser
      .mutateAsync(toggleState)
      .then((res) => {
        toast("Succesful");
        setLoading(false);
        refetch();
        console.log(res);
      })
      .catch((e) => {
        setLoading(false);
      });
  };
  return (
    <div className="h-screen p-5 md:pr-5 md:pl-8 w-full">
      <div className="flex items-center gap-3 mb-3">
        <div
          onClick={() => navigate(-1)}
          className="h-8 w-8 rounded-full bg-[#F7FBFB] flex items-center justify-center cursor-pointer"
        >
          <IoChevronBackOutline />
        </div>
        <p>Manage user</p>
      </div>
      <h1 className="text-[#071827] font-bold text-xl mb-4">
        {account?.ngnLBPAccountName}
      </h1>
      <div className="  bg-[#FEFEFF] ">
        <div className=" bg-[#F7FBFB] rounded-xl w-full  h-fit px-7 py-5 flex flex-col gap-8">
          <div className="flex items-center justify-between ">
            <div>
              <span className="text-[#071827] font-normal ">Manage</span>
            </div>
            <div className="flex items-center ">
              <span className="text-[#5C6F7F] text-[16px] leading-[30px] ">
                Toggle all
              </span>
              {loading ? (
                <svg
                  className="animate-spin h-6 w-16 text-center text-[#0D9A6F]"
                  width="14px"
                  height="14px"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.2"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                    fill="black"
                  />
                  <path
                    d="M2 12C2 6.47715 6.47715 2 12 2V5C8.13401 5 5 8.13401 5 12H2Z"
                    fill="#0D9A6F"
                  />
                </svg>
              ) : (
                <ToggleSwitch
                  value={switchToggle}
                  onChange={(e) => handleToggleAll(e)}
                  label={""}
                  isLoading={false}
                />
              )}
            </div>
          </div>

          <div>
            {functionality?.data?.data?.map((fnx: any, index: any) => {
              return (
                <div key={index}>
                  <SettingsData
                    fnx={fnx}
                    id={fnx?.id}
                    DeleteModal={setDeleteModalOpen}
                    description={`${_.startCase(fnx?.feature)}`}
                    setShowEdit={setShowEdit}
                    onToggleChange={handleToggleChange}
                    subtext={_.startCase(fnx?.description)}
                    status={fnx?.status}
                    load={loading}
                    showEdit={false}
                    toggleAll={toggleAll}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="">
        <StepperController  currentStep={0} onSubmit={function (): void {
          throw new Error("Function not implemented.");
        } } />
      </div>
    </div>
  );
};

export default IndividualFunctionality;
